<div class="nav-header">
  <a class="brand-logo pe-5" (click)="goToDashboard()">
    <img src="/assets/logos/core/acibadem-mobil-logo.png" alt="Coreaid Mobil Logo"/>
  </a>

  <div class="nav-control">
    <div class="hamburger">
      <span class="line"></span>
      <span class="line"></span>
      <span class="line"></span>
    </div>
  </div>
</div>

<div class="header is-fixed">
  <div class="header-content">
    <nav class="navbar navbar-expand">
      <div class="collapse navbar-collapse justify-content-end">
        <div class="header-left"></div>

        <ul class="navbar-nav header-right custom-header-menu-right">
          <ng-container *ngFor="let menu of headerMenu">
            <li class="header-menu-title" *ngIf="menu.urlType=='GROUP'">{{ menu.title }}</li>
            <ng-container>
              <ng-container
                *ngTemplateOutlet="
                  headerMenuTemp;
                  context: { items: (menu.items && menu.items.length>0 && menu.urlType=='GROUP')?menu.items:[menu] }
                "
              ></ng-container>
            </ng-container>
          </ng-container>
        </ul>

        <ul class="navbar-nav header-right">
          <li class="nav-item dropdown notification_dropdown">
            <button class="nav-link bell-link" (click)="openSearch()" [attr.aria-label]="'Open Search'">
                   <i class="pi pi-search text-white text-lg" style="color: white;"></i>
            </button>
          </li>

          <li class="nav-item dropdown notification_dropdown">
          <button class="nav-link bell-link" (click)="openMessagesSidebar()" aria-label="Open Messages">
            <i class="pi pi-bell text-white text-lg"></i>
            <span *ngIf="hasUnreadNotifications"
                  class="badge badge-sm badge-danger p-1 mb-2"
                  aria-label="Unread notifications"></span>
          </button>
          </li>

          <li class="nav-item dropdown notification_dropdown">
            <button class="nav-link bell-link" (click)="toggleFullscreen()" aria-label="Toggle Fullscreen">
              <i class="pi pi-window-maximize text-white text-lg" *ngIf="!isFullscreen"></i>
              <i class="pi pi-window-minimize text-white text-lg" *ngIf="isFullscreen"></i>
            </button>
          </li>

          <li class="nav-item dropdown notification_dropdown">
              <button class="nav-link bell-link" (click)="toogleShortcut()" aria-label="Toggle Shortcut">
                <i class="pi pi-th-large text-white text-lg"></i>
              </button>
          </li>

          <li class="nav-item ps-3">
            <div class="dropdown header-profile2">
              <button class="nav-link" data-bs-toggle="dropdown" aria-expanded="false" tabindex="0">
                <div class="header-info2 d-flex align-items-center" *ngIf="user">
                  <div class="header-media">
                    <img [src]="photo || '../../../assets/theme/w3crm/images/avatar/1.jpg'" alt="User Avatar"/>
                  </div>
                  <div class="header-info">
                    <h6>{{ user.firstName }} {{ user.lastName }}</h6>
                    <p>{{ user.email }}</p>
                  </div>
                </div>
              </button>

              <div class="dropdown-menu dropdown-menu-end">
                <div class="card border-0 mb-0">
                  <div class="card-header py-2">
                    <div class="header-user-info" *ngIf="user">
                      <img [src]="photo || '../../../assets/theme/w3crm/images/avatar/1.jpg'" class="avatar avatar-md"
                           alt="User Avatar"/>
                      <div class="info">
                        <h6>{{ user.firstName }} {{ user.lastName }}</h6>
                        <span>{{ user.email }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 pe-3 ps-3 pt-2 pb-2">
                    <div class="input-group">
                      <input type="number" class="form-control no-focus" [(ngModel)]="station"
                             placeholder="{{'general.station' | translate}}" [attr.aria-label]="'Station Number'"/>
                      <button class="input-group-text btn-success btn pt-2 ps-2 pe-2" (click)="saveStation()"
                              [attr.aria-label]="'Save Station'">
                        <i class="bi bi-save"></i>
                      </button>
                    </div>
                  </div>

                  <div class="card-footer px-0 py-2">
                    <app-my-reports></app-my-reports>
                    <a [routerLink]="['/settings']" class="dropdown-item ai-icon wave-effect">
                      <span class="ms-2">{{ 'general.header.settings' | translate }} </span>
                    </a>
                    <button (click)="logout()" class="btn btn-sm ai-icon float-right" [attr.aria-label]="'Logout'">
                      <span class="ms-2 text-danger">Logout </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</div>

<ng-template #headerMenuTemp let-items="items">
  <ul>
    <li *ngFor="let item of items" class="nav-item dropdown notification_dropdown custom-header-menu-item">
      <ng-container *ngIf="item.urlType!='GROUP'">
        <button class="nav-link bell-link"
                *ngIf="(!item.items || item.items.length==0)"
                (click)="handleItemClick(item)"
                [attr.aria-label]="item.title">
          <span [innerHTML]="item.icon" class="icon custom-header-icon"></span>
          <span class="ms-2 title">{{ item.title }}</span>
        </button>

        <button *ngIf="item.items && item.items.length>0" class="nav-link" data-bs-toggle="dropdown"
                aria-expanded="true">
          <span [innerHTML]="item.icon" class="icon custom-header-icon"></span>
          <span class="ms-2 title">{{ item.title }}</span>
        </button>

        <div *ngIf="item.items && item.items.length>0" class="dropdown-menu dropdown-menu-start header-dropdown-area"
             data-bs-popper="static">
          <ng-container *ngTemplateOutlet="headerMenuTemp; context: { items: item.items }"></ng-container>
        </div>
      </ng-container>
    </li>
  </ul>
</ng-template>

<app-core-messages-canvas #coreMessagesUserCanvas></app-core-messages-canvas>
<app-icd-codes-popup #icdCodePopup></app-icd-codes-popup>
<app-call-receiving-popup [hidden]="minimizeCallCard" #callReceivingPopup></app-call-receiving-popup>
<core-medical-advice-dialog #dashboardMedicalAdviceDialog></core-medical-advice-dialog>
<core-app-currency-dialog #currencyDialog></core-app-currency-dialog>
<app-vehicle-location-map #vehicleLocationMap></app-vehicle-location-map>
<app-dashboard-map #dashboardMap></app-dashboard-map>
<app-search></app-search>
<app-shortcut></app-shortcut>
<app-password-change-popup #passwordChangePopup></app-password-change-popup>

<button class="bobble-button" (click)="minimizeCallCardSet(minimizeCallCard=!minimizeCallCard)"
        *ngIf="bobbleButton && openCall.length>0" [attr.aria-label]="'Open Call Card'">
  <i class="count">{{ openCall.length }}</i>
  <i class="hicon fa-solid fa-headset"></i>
  <button (click)="bobbleButton=false" class="close-btn" [attr.aria-label]="'Close Call Card'">
    <i class="fa-solid fa-close close"></i>
  </button>
</button>
